import { useCallback } from 'react'
import type {
  ActivitySummaryDTO,
  ActivitySummaryFilterSet,
} from '../../../typings'
import { useAppDispatch } from '@user/store/hooks'
import { serializeFilters } from '@user/components/Filters'
import { useActivitySummaryContext } from '../../../context'
import { saveFilterPreference } from '@user/store/userPreferences'
import { setActivitySummaryFiltersActionCreator as setFilters } from '../../../state'

export function useHandlers() {
  const [{ filterCacheId }, dispatch] = useActivitySummaryContext()

  const appDispatch = useAppDispatch()

  const applyFilters = useCallback(
    (filters: ActivitySummaryFilterSet) => {
      appDispatch(
        saveFilterPreference({
          id: filterCacheId,
          type: 'activitySummary',
          name: 'activity summary filters',
          filter: serializeFilters<
            ActivitySummaryDTO,
            ActivitySummaryFilterSet
          >(filters),
        }),
      )

      dispatch(setFilters(filters))
    },
    [appDispatch, dispatch, filterCacheId],
  )

  return {
    applyFilters,
  }
}
